// extracted by mini-css-extract-plugin
module.exports = {"opportunityDescription":"_c9142a1","marketIcon":"_4b9a185","inPlayIcon":"_ec033a8"};